import CenteredLayout from "@common/components/thirdParty/mantine/layout/CenteredLayout";
import { generateBEAPIUrl } from "@utils/api";
import { Center, Loader } from "@mantine/core";
import type { GetServerSideProps } from "next";
import { ReactElement } from "react";

export const getServerSideProps: GetServerSideProps = async ({ req }) => {
  try {
    const response = await fetch(generateBEAPIUrl("/account"), {
      headers: {
        accept: "application/json",
        ...(req.headers.cookie ? { cookie: req.headers.cookie } : {}),
      },
    });

    if (response.ok) {
      return {
        redirect: {
          destination: "/account",
          permanent: false,
        },
      };
    }
  } catch {
    // The client-side account check handles auth when the session cookie is
    // unavailable to the root request.
  }

  return {
    props: {},
  };
};

export default function IndexPage(): ReactElement {
  return (
    <CenteredLayout maxWidth="100%" padding={0}>
      <Center w="100%" h="100vh">
        <Loader />
      </Center>
    </CenteredLayout>
  );
}

IndexPage.hideNav = true;
